import React, { createContext, useState } from 'react';

export const AppExtContext = createContext();

const ExternalContext = ({children}) => {
    const [extLoginInfo, setExtLoginInfo] = useState();
    const [targetIdx, setTargetIdx] = useState();
    return (
        <AppExtContext.Provider
            value={{
                setLogin : setExtLoginInfo,
                loginInfo : extLoginInfo,
                setTargetIdx,
                targetIdx
            }}
        >
            {children}
        </AppExtContext.Provider>
    );
};

export default ExternalContext;